/**
 * The Validation Messages in this application
 */
export default class ValidateMessages {
    static incorrect: string = 'The field value is incorrect';
    static incorrectType = (type: string) => `The value must be a valid ${type}`;
    static required: string = 'This field is required';
    static minLength = (type: string, length: number) => `${type} must be at least ${length} characters`
}
